import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/meclee-ui/images/b-3.svg")